<loading *ngIf="loading" content="Loading..."></loading>

<div *ngIf="!record.estimateNumber; else pricingTemplate" class="text-center p-4 mt-4">
  <h2 class="text-secondary">Sorry, but we couldn't find an estimate.</h2>
  <p class="text-muted p-2">
    <i class="fas fa-fw fa-lg text-info fa-info-circle"></i>
    You'll need to finish your quote and send it on to estimating before you can adjust pricing.
  </p>
</div>
<ng-template #pricingTemplate>
  <div class="row">
    <div class="col-6 form-group">
      <label>Estimate</label>
      <h4 class="text-secondary">
        {{record.estimateNumber}}
        <span *ngIf="relatedEstimate" class="badge status text-uppercase p-1 pl-2 pr-2" [ngClass]="getStatusColorClass(relatedEstimate.status)">
          <i *ngIf="isEstimateReady(relatedEstimate.status); else notReady" class="fa fa-fw fa-check"></i>
          <ng-template #notReady>
            <i class="fa fa-fw fa-exclamation-triangle"></i>
          </ng-template>
          {{getStatusText(relatedEstimate.status)}}
        </span>
        <span *ngIf="relatedEstimate" class="small pl-4">
          <a title="Open Estimate" class="small text-muted" target="_blank" [routerLink]="'/order/' + relatedEstimate.orderSegmentId"><i class="fa fas fa-fw fa-external-link-alt"></i>Open Estimate</a>
        </span>
      </h4>
    </div>
    <div class="col-2" *ngIf="!editing">
      <button class="btn btn-primary" (click)="getDownloadableQuote()">
        <i class="fas fa-fw fa-lg fa-file-download"></i>
        Download Quote
      </button><br>
      <button class="btn btn-primary mt-1" (click)="promptForVendorTemplate()" *ngIf="record.customer.businessName.toLowerCase().includes('sikorsky')">
        <i class="fas fa-fw fa-lg fa-file-download"></i>
        Download Vendor Export
      </button>
    </div>
    <div class="col-4" *ngIf="!editing && userCanAccept && (record.status == 8 || record.status == 99)">
      <button class="btn btn-info" (click)="beginAcceptance()" [disabled]="!allQuantitiesSelected">
        <i class="fas fa-fw fa-arrow-right-from-bracket"></i>
        Accept PO Against Quote
      </button>
    </div>
  </div>
  <quote-items-table [record]="record"></quote-items-table>
</ng-template>

<ng-template #vendorTemplateExport let-data>
  <h1 mat-dialog-title>
    Select a template to use
  </h1>
  <div mat-dialog-content *ngLet="vendorTemplateLoading | async as templateLoading">
    <div class="row" *ngIf="templateLoading">
      <h2>Loading vendor template...</h2>
    </div>
    <div class="row" *ngIf="!templateLoading">
      <mat-card title="Select document" (click)="data.retrieveVendorExport(doc.documentId)" *ngFor="let doc of data.documents" class="d-inline-block mr-2 mb-3">
        <mat-card-header>
          <mat-card-title class="text-center display-block w-100">
            <i class="fa-fw fa-3x text-info fas fa-file-excel"></i>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="text-center">
          <span class="text-muted docname" [title]="doc.name">{{doc.name}}</span>
        </mat-card-content>
      </mat-card>
      <mat-card title="Local file" (click)="fileInput.click()" class="d-inline-block mr-2 mb-3">
        <mat-card-header>
          <mat-card-title class="text-center display-block w-100">
            <i class="fa-fw fa-3x text-info fas fa-file-upload"></i>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="text-center">
          <span class="text-muted docname" title="Upload">Upload local file</span>
        </mat-card-content>
      </mat-card>
      <input hidden type="file" multiple #fileInput (change)="data.retrieveVendorExport(null, $event.target.files[0])">
    </div>
  </div>
  <div mat-dialog-actions class="justify-content-end">
    <button class="button-text" mat-stroked-button matDialogClose>Close</button>
  </div>
</ng-template>